module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-8.9eb0cc48.png";